import { FC } from 'react';
import { Button } from '@kontentino/ui';
import PermissionsGateButton from 'app/components/PermissionsGateButton';
import PageTypeUtils from 'app/utils/pageType';
import WorkflowStatusSelector from 'app/components/workflowStatus/WorkflowStatusSelector';
import UserPermissionGate from 'components/UserPermissionGate';
import { UserPermission } from 'constants/userPermission';
import { useTranslation } from 'react-i18next';

type Props = {
  onCancelClick: () => void;
  onSaveClick: () => void;
  onPostStatusChange?: (status: number) => void;
  confirmButtonLabel?: string;
  postStatus: number;
  pageType: number;
};

const PostComposerModalFooter: FC<Props> = ({
  onCancelClick,
  onSaveClick,
  onPostStatusChange,
  postStatus,
  pageType,
  confirmButtonLabel,
}) => {
  const { t } = useTranslation();
  return (
    <div className="tw-flex tw-items-center tw-justify-between tw-bg-grayscale-30 tw-px-6 tw-py-3">
      <div className="tw-flex-1">
        <UserPermissionGate scopes={UserPermission.POST_EDIT_STATUS}>
          <>
            {onPostStatusChange && (
              <WorkflowStatusSelector
                pageType={pageType}
                value={postStatus}
                onChange={onPostStatusChange}
                dataCy={{
                  placeholder: 'posts-form-workflow-status-selector',
                  option: 'posts-form-workflow-selector-option',
                }}
              />
            )}
          </>
        </UserPermissionGate>
      </div>
      <div className="tw-ml-auto tw-flex tw-items-center tw-gap-4">
        <Button
          data-name="posts-composer-cancel"
          data-cy="posts-form-cancel-button"
          variant="secondary"
          onClick={onCancelClick}
        >
          {t('cancel')}
        </Button>
        <PermissionsGateButton
          data-name="posts-composer-save"
          data-cy="post-form-save-button"
          data-social-media={PageTypeUtils.getName(pageType)}
          scopes={[]}
          onClick={onSaveClick}
          className="tw-w-[130px]"
        >
          {confirmButtonLabel ?? t('save')}
        </PermissionsGateButton>
      </div>
    </div>
  );
};

export default PostComposerModalFooter;
